export default __webpack_public_path__ + "assets/images/1beb5aea1518dd349cdb518322b92277.jpg";